(function () {
  function enhanceSizeGuide() {
    document.querySelectorAll('[id^="ProductInfo-"]').forEach(function (productInfo) {
      if (productInfo.dataset.civettaSizeGuideReady === 'true') return;

      var guideButton = productInfo.querySelector('#ProductPopup-1');
      var guideBlock = guideButton && guideButton.closest('.product_additional_information');
      var sizeField = Array.prototype.slice.call(productInfo.querySelectorAll('.product-form__input.radio--swatch')).find(
        function (field) {
          return Array.prototype.slice.call(field.querySelectorAll('input[type="radio"]')).some(function (input) {
            return input.name.toLowerCase() === 'size';
          });
        }
      );
      var sizeLegend = sizeField && sizeField.querySelector('.form__label');

      if (!guideBlock || !sizeField || !sizeLegend) return;

      var heading = document.createElement('div');
      heading.className = 'civetta-size-option-heading';
      sizeField.insertBefore(heading, sizeField.firstChild);
      heading.appendChild(sizeLegend);

      var chartTrigger = document.createElement('button');
      chartTrigger.className = 'civetta-size-chart-trigger';
      chartTrigger.type = 'button';
      chartTrigger.setAttribute('aria-haspopup', 'dialog');
      chartTrigger.setAttribute('aria-label', 'Open the Civetta size chart');

      var guideIcon = guideButton.querySelector('svg');
      var guideIconTemplate = guideIcon && guideIcon.cloneNode(true);

      function renderSizeChartTrigger() {
        var currentIcon = chartTrigger.querySelector('svg');
        var currentLabel = chartTrigger.querySelector('.civetta-size-guide-label');
        if (currentIcon && currentLabel && currentLabel.textContent === 'Size chart') return;

        chartTrigger.replaceChildren();
        if (guideIconTemplate) chartTrigger.appendChild(guideIconTemplate.cloneNode(true));

        var stableLabel = document.createElement('b');
        stableLabel.className = 'civetta-size-guide-label';
        stableLabel.textContent = 'Size chart';
        chartTrigger.appendChild(stableLabel);
      }

      renderSizeChartTrigger();
      new MutationObserver(renderSizeChartTrigger).observe(chartTrigger, {
        childList: true,
        characterData: true,
        subtree: true
      });
      chartTrigger.addEventListener('click', function () {
        guideButton.click();
      });
      heading.appendChild(chartTrigger);

      guideBlock.classList.add('civetta-size-guide-source');
      guideBlock.setAttribute('aria-hidden', 'true');
      guideButton.tabIndex = -1;

      var modal = document.querySelector('#PopupModal-1');
      if (modal && modal.dataset.civettaSizeModalReady !== 'true') {
        var modalContent = modal.querySelector('.product-popup-modal__content');
        var modalHeader = modal.querySelector('.modal-header');
        var modalTitle = modal.querySelector('.modal__title');

        if (modalContent && modalHeader && modalTitle) {
          modalContent.classList.add('civetta-size-modal');
          modal.setAttribute('aria-label', 'Civetta size guide');

          var chartImage = modalContent.querySelector('.product-popup-modal__content-info img');
          if (chartImage) {
            chartImage.loading = 'eager';
            chartImage.fetchPriority = 'low';
            chartImage.decoding = 'async';
            chartImage.sizes = '(max-width: 749px) calc(100vw - 48px), 856px';
          }

          var titleGroup = document.createElement('div');
          titleGroup.className = 'civetta-size-modal-heading';

          var eyebrow = document.createElement('span');
          eyebrow.className = 'civetta-size-modal-eyebrow';
          eyebrow.textContent = 'Civetta fit guide';

          var subtitle = document.createElement('p');
          subtitle.className = 'civetta-size-modal-subtitle';
          subtitle.textContent = 'Compare your measurements for a more confident fit.';

          modalTitle.textContent = 'Find your fit';
          modalHeader.insertBefore(titleGroup, modalTitle);
          titleGroup.appendChild(eyebrow);
          titleGroup.appendChild(modalTitle);
          titleGroup.appendChild(subtitle);
          modal.dataset.civettaSizeModalReady = 'true';
        }
      }

      productInfo.dataset.civettaSizeGuideReady = 'true';
    });
  }

  function initStickyBar(bar) {
    if (!bar || bar.dataset.civettaReady === 'true') return;
    bar.dataset.civettaReady = 'true';
    bar.dataset.civettaVersion = 'premium-options-9';

    var sectionId = bar.dataset.section;
    var productInfo = document.querySelector('#ProductInfo-' + sectionId);
    var mainForm = document.querySelector('#product-form-' + sectionId);
    var mainBuyArea = productInfo && productInfo.querySelector('.product_buy_button_form');
    var stickyInput = bar.querySelector('input[name="id"]');
    var stickyButton = bar.querySelector('button[name="add"]');
    var stickyImage = bar.querySelector('[data-sticky-image]');
    var selection = bar.querySelector('[data-sticky-selection]');
    var price = bar.querySelector('[data-sticky-price]');
    var optionsTrigger = bar.querySelector('[data-sticky-options-trigger]');
    var optionsPanel = bar.querySelector('[data-sticky-options-panel]');
    var optionChoices = Array.prototype.slice.call(bar.querySelectorAll('[data-sticky-option-value]'));
    var variantMapElement = bar.querySelector('[data-sticky-variant-map]');
    var variantMap = {};
    var isSelectingOption = false;
    var lastOptionIndex = optionChoices.reduce(function (highestIndex, choice) {
      return Math.max(highestIndex, Number(choice.dataset.stickyOptionIndex));
    }, 0);

    if (variantMapElement) {
      try {
        variantMap = JSON.parse(variantMapElement.textContent);
      } catch (error) {
        variantMap = {};
      }
    }

    function setOptionsOpen(shouldOpen) {
      if (!optionsPanel || !optionsTrigger) return;
      optionsPanel.hidden = !shouldOpen;
      optionsTrigger.setAttribute('aria-expanded', String(shouldOpen));
      bar.classList.toggle('options-open', shouldOpen);
      document.body.classList.toggle('sticky__options-open', shouldOpen);
    }

    function syncChoiceState(variant) {
      if (!variant || !variant.options) return;
      optionChoices.forEach(function (choice) {
        var optionIndex = Number(choice.dataset.stickyOptionIndex);
        var isSelected = variant.options[optionIndex] === choice.dataset.stickyOptionValue;
        choice.setAttribute('aria-pressed', String(isSelected));
      });
    }

    function syncGallery(variant) {
      if (!variant || !variant.featuredMediaId) return;
      var target = sectionId + '-' + variant.featuredMediaId;
      var thumbnail = document.querySelector('[data-target="' + target + '"] .thumbnail');
      if (thumbnail && thumbnail.getAttribute('aria-current') !== 'true') {
        thumbnail.click();
      }
    }

    function syncMainOptionLabel(input) {
      var field = input && input.closest('.product-form__input');
      var valueLabel = field && field.querySelector('.form__label span');
      if (valueLabel && input.value) valueLabel.textContent = input.value;
    }

    function applyVariant(variant, variantId) {
      if (!variant) return;
      if (stickyInput && variantId) stickyInput.value = variantId;
      if (selection) selection.textContent = variant.label;
      if (price) price.textContent = variant.price;
      if (stickyImage && variant.image) {
        stickyImage.src = variant.image;
        stickyImage.alt = variant.imageAlt || variant.label;
      }

      syncChoiceState(variant);
      syncGallery(variant);

      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        var label = stickyButton.querySelector('[data-sticky-button-label]');
        if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    function syncVariant() {
      if (!mainForm || !stickyInput) return;
      var mainInput = mainForm.querySelector('input[name="id"]');
      if (!mainInput || !mainInput.value) return;
      applyVariant(variantMap[mainInput.value], mainInput.value);
    }

    function selectOption(choice) {
      if (!productInfo) return;
      var optionName = choice.dataset.stickyOptionName;
      var optionValue = choice.dataset.stickyOptionValue;
      var mainChoice = Array.prototype.slice.call(productInfo.querySelectorAll('input[type="radio"]')).find(
        function (input) {
          return input.name === optionName && input.value === optionValue;
        }
      );

      if (!mainChoice || mainChoice.disabled) return;
      if (!mainChoice.checked) {
        isSelectingOption = true;
        mainChoice.click();
        isSelectingOption = false;
      }
      syncMainOptionLabel(mainChoice);

      var optionNames = [];
      optionChoices.forEach(function (optionChoice) {
        optionNames[Number(optionChoice.dataset.stickyOptionIndex)] = optionChoice.dataset.stickyOptionName;
      });

      var selectedOptions = optionNames.map(function (name) {
        var checkedOption = Array.prototype.slice.call(productInfo.querySelectorAll('input[type="radio"]')).find(
          function (input) {
            return input.name === name && input.checked;
          }
        );
        return checkedOption && checkedOption.value;
      });

      var matchedVariantId = Object.keys(variantMap).find(function (variantId) {
        var variant = variantMap[variantId];
        return variant.options.every(function (value, index) {
          return value === selectedOptions[index];
        });
      });

      if (matchedVariantId) applyVariant(variantMap[matchedVariantId], matchedVariantId);
      if (Number(choice.dataset.stickyOptionIndex) === lastOptionIndex) setOptionsOpen(false);

      window.requestAnimationFrame(syncVariant);
      window.setTimeout(syncVariant, 90);
      window.setTimeout(syncVariant, 220);
    }

    function toggleStickyBar() {
      if (!mainBuyArea) return;
      var shouldShow = mainBuyArea.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('sticky', shouldShow);
      document.body.classList.toggle('sticky__cart', shouldShow);
      if (!shouldShow) setOptionsOpen(false);
    }

    document.addEventListener('click', function (event) {
      var clickedTrigger = event.target.closest && event.target.closest('[data-sticky-options-trigger]');
      var clickedClose = event.target.closest && event.target.closest('[data-sticky-options-close]');
      var clickedChoice = event.target.closest && event.target.closest('[data-sticky-option-value]');

      if (clickedTrigger && bar.contains(clickedTrigger)) {
        event.preventDefault();
        setOptionsOpen(optionsPanel.hidden);
        return;
      }

      if (clickedClose && bar.contains(clickedClose)) {
        event.preventDefault();
        setOptionsOpen(false);
        optionsTrigger.focus();
        return;
      }

      if (clickedChoice && bar.contains(clickedChoice)) {
        event.preventDefault();
        selectOption(clickedChoice);
        return;
      }

      if (isSelectingOption) return;

      if (optionsPanel && !optionsPanel.hidden && !bar.contains(event.target)) {
        setOptionsOpen(false);
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && optionsPanel && !optionsPanel.hidden) {
        setOptionsOpen(false);
        optionsTrigger.focus();
      }
    });

    document.addEventListener('change', function (event) {
      if (!event.target.closest('#ProductInfo-' + sectionId)) return;
      syncMainOptionLabel(event.target);
      window.requestAnimationFrame(syncVariant);
      window.setTimeout(syncVariant, 90);
      window.setTimeout(syncVariant, 220);
    });

    window.addEventListener('scroll', toggleStickyBar, { passive: true });
    window.addEventListener('resize', toggleStickyBar, { passive: true });
    syncVariant();
    toggleStickyBar();
  }

  function initAllStickyBars() {
    document.querySelectorAll('[data-civetta-product-sticky]').forEach(initStickyBar);
    enhanceSizeGuide();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStickyBars);
  } else {
    initAllStickyBars();
  }

  document.addEventListener('shopify:section:load', initAllStickyBars);
})();


